'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


var nullFunc = function nullFunc() {};

var analytics = function analytics(ga) {
    return ga || typeof window !== 'undefined' && window.ga || nullFunc;
};

var trackUserId = exports.trackUserId = function trackUserId(userId, ga) {
    return analytics(ga)('set', 'userId', userId);
};

var trackRoute = exports.trackRoute = function trackRoute(route, ga) {
    return analytics(ga)('send', 'pageview', route);
};

var trackEvent = exports.trackEvent = function trackEvent(category, action, label, ga) {
    return analytics(ga)('send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/misc/Analytics.js
// module id = 93
// module chunks = 0